import { render } from "./JsonDisplay.vue?vue&type=template&id=4109a468"
import script from "./JsonDisplay.vue?vue&type=script&lang=js"
export * from "./JsonDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__